module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "toc_head"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926474_epub_itr_r1#itr"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926474_epub_p01_r1"
    }
  }, [_c('span', {
    staticClass: "csans_big"
  }, [_c('strong', [_vm._v("PART 1: SALATO")])]), _vm._v(" "), _c('span', {
    staticClass: "csans_small"
  }, [_c('strong', [_vm._v("(SAVORY)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c01_r1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 1:")])]), _vm._v(" "), _c('em', [_vm._v("Antipasti")]), _vm._v(" (Appetizers)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 2:")])]), _vm._v(" "), _c('em', [_vm._v("Primi")]), _vm._v(" (First Courses)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 3:")])]), _vm._v(" "), _c('em', [_vm._v("Secondi")]), _vm._v(" (Main Courses)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 4:")])]), _vm._v(" "), _c('em', [_vm._v("Zuppe")]), _vm._v(" (Soups)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 5:")])]), _vm._v(" "), _c('em', [_vm._v("Insalate Fredde")]), _vm._v(" (Cold Salads)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 6:")])]), _vm._v(" Pizzas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 7:")])]), _vm._v(" "), _c('em', [_vm._v("Contorni")]), _vm._v(" (Sides)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "csans_big"
  }, [_c('strong', [_vm._v("PART 2: DOLCE")])]), _vm._v(" "), _c('span', {
    staticClass: "csans_small"
  }, [_c('strong', [_vm._v("(SWEET)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 8:")])]), _vm._v(" "), _c('em', [_vm._v("Dolce")]), _vm._v(" (Desserts)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CHAPTER 9:")])]), _vm._v(" "), _c('em', [_vm._v("L’Arte Del Gelato")]), _vm._v(" (The Art of Gelato)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454926474_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8099d604","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926474_epub_toc_r1.vue
// module id = 69
// module chunks = 0